import React, { useContext, useEffect, useRef, useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell";
import AddIcon from "@material-ui/icons/Add";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import { useParams } from "react-router-dom";
import Box from "@material-ui/core/Box";
import CustomMenu from "../../../../../../components/Menu/CustomMenu";
import { tesaBlue, tesaGrey1, tesaGrey5 } from "../../../../../../styles/colors";
import TestRequestApi from "../../../../../../api/services/TestRequestApi";
import ProductSection from "../../../../../../api/models/test-series/ProductSection";
import useEnv from "../../../../../../hooks/env";
import ErrorSnackbarContext from "../../../../../../contexts/ErrorSnackbarContext";
import ProductActionValueGroup from "../../../../../../api/models/test-series/ProductActionValueGroup";
import RequestsPagePathParams from "../../../../../../api/models/test-request/RequestsPagePathParams";
import ProductSide from "../../../../models/ProductSide.model";
import ProductType from "../../../../../../api/models/product/ProductType";

type ProductSample = {
  id: number;
  type: ProductType;
  productSampleName: string;
  sideOfProduct: ProductSide;
};

const useStyles = makeStyles({
  label: {
    color: tesaGrey1,
    fontFamily: "Proxima Nova Bold",
    fontSize: "1rem",
    fontColor: "Black",
    borderLeft: "1px solid",
    borderLeftColor: tesaGrey5,
  },
  addIcon: {
    color: "#B1B2B3",
    float: "right",
  },
  columnHeadline: {
    color: "black",
  },
});

const StyledMenuItem = withStyles((theme) => ({
  root: {
    "&:focus": {
      backgroundColor: tesaBlue,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

interface TestSeriesProductHeaderProps {
  enabled: boolean;
  cellSizeInPercent: number;
  handleAddProduct: (productActionValueGroup: ProductActionValueGroup) => void;
  product: ProductSection;
}

const TestSeriesProductHeader: React.FunctionComponent<TestSeriesProductHeaderProps> = (props) => {
  const { api } = useEnv();
  const testRequestApi: TestRequestApi = new TestRequestApi(api);
  const [productSamples, setProductSamples] = useState<ProductSample[]>([]);
  const { enabled, cellSizeInPercent, handleAddProduct, product } = props;

  const classes = useStyles();
  const { testRequestId } = useParams<RequestsPagePathParams>();
  const { handleHttpError } = useContext(ErrorSnackbarContext);
  const menuRef = useRef({ close: () => {} });

  const createProductActionFlowObject = (productSample: ProductSample): ProductActionValueGroup => {
    return {
      productSampleId: productSample.id,
      sideOfProduct: productSample.sideOfProduct,
      actionFlow: {
        actionValues: [],
        name: productSample.productSampleName,
      },
    };
  };

  const loadProducts = () => {
    testRequestApi
      .getTestRequest(testRequestId)
      .then((res) =>
        setProductSamples(
          res.data.productSampleReferences?.map((reference) => ({
            ...(reference.productSample as ProductSample),
          })) || [],
        ),
      )
      .catch(handleHttpError);
  };

  useEffect(() => {
    loadProducts();
  }, []);

  return (
    <TableCell width={`${cellSizeInPercent}%`} align="left" className={classes.label}>
      <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between">
        <b className={classes.columnHeadline}>
          Product
          {product.name.toLowerCase() !== "material" && ` (${product.name})`}
        </b>
        {enabled && (
          <CustomMenu alternativeButtonIcon={<AddIcon className={classes.addIcon} />} ref={menuRef}>
            {productSamples &&
              productSamples.map((productSample) => {
                const productActionFlowObject = createProductActionFlowObject(productSample);
                return (
                  <StyledMenuItem
                    key={productSample.id}
                    onClick={() => {
                      handleAddProduct(productActionFlowObject);
                      menuRef.current.close();
                    }}
                  >
                    <ListItemText primary={productSample.productSampleName} />
                  </StyledMenuItem>
                );
              })}
          </CustomMenu>
        )}
      </Box>
    </TableCell>
  );
};
export default TestSeriesProductHeader;
